import { IconButton } from '@mui/material';
import React, { forwardRef, useState } from 'react';

const AryIconButton = forwardRef((props, ref) => {
  const {
    borderColor,
    focusStyles,
    Icon,
    disabled,
    disabledIconColor,
    iconColor,
    borderRadius,
    sx
  } = props;
  const [isFocused, setIsFocused] = useState(false);

  return (
    <IconButton
      ref={ref}
      {...props}
      sx={{
        borderRadius: borderRadius || '0.5rem',
        border: `0.0625rem solid ${borderColor}`,
        '&.Mui-focusVisible': {
          border: `${
            focusStyles && `0.0625rem solid ${focusStyles.borderColor}`
          }`,
          boxShadow: focusStyles && focusStyles.boxShadow,
          bgcolor: focusStyles && focusStyles.background
        },
        ...sx
      }}
      onFocus={() => setIsFocused(true)}
      onBlur={() => setIsFocused(false)}
    >
      <Icon
        style={{
          color: disabled
            ? disabledIconColor
            : isFocused
            ? focusStyles
              ? focusStyles.icon
              : iconColor
            : iconColor,
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      />
    </IconButton>
  );
});
export default AryIconButton;
